/**
 * The Xero sales account and tax rate the current practice invoices with by default - set in Practice
 * details. Until the practice chooses, they are Xero's own starting ones: the Sales account (200) and the
 * country's GST on sales (OUTPUT2 in New Zealand, OUTPUT in Australia).
 *
 * Read once per practice and kept; saving them in settings replaces the kept copy.
 */
app.service("PracticeBillingDefaults", [
	"$q",
	"Session",
	"PracticeService",
	"countryConfig",
	function ($q, Session, PracticeService, countryConfig) {
		const fallback = () => ({
			salesAccountCode: "200",
			taxType: countryConfig.countryCode === "AU" ? "OUTPUT" : "OUTPUT2",
		});

		let practiceId = null;
		let promise = null;

		// The saved values with the country's standing in for anything unset.
		function effective(saved) {
			const d = fallback();
			return {
				salesAccountCode: (saved && saved.sales_account_code) || d.salesAccountCode,
				taxType: (saved && saved.tax_type) || d.taxType,
			};
		}

		const service = {
			fallback,
			effective,

			// Resolves to { salesAccountCode, taxType }; never rejects - an invoice is still raised on
			// the country's defaults when the practice's can't be read.
			load: function () {
				const current = Session.practice && Session.practice.id;
				if (promise && practiceId === current) return promise;
				practiceId = current;
				promise = PracticeService.queryBillingDefaults(current).then(
					(resp) => effective(resp.data),
					function () {
						promise = null;
						return fallback();
					}
				);
				return promise;
			},

			// A save in settings: the next load reads the new values.
			saved: function (savedForPracticeId, saved) {
				if (savedForPracticeId === practiceId) promise = $q.resolve(effective(saved));
			},
		};

		return service;
	},
]);
